import { NoCardEntryRequest as USSportsNoCardEntryRequest } from '@sorare/us-sports/src/components/lobby/NoCardEntry/routes/request';

const NoCardEntryRequest = () => <USSportsNoCardEntryRequest />;

export default NoCardEntryRequest;
